// deps
import React, { memo, useRef } from "react";

// internal deps
import { default as IconChevronVariant } from "@swiggy-private/dls-web-icons/dist/web/generic/chevronRight/16";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

// styles
import {
    NonAppliedContainer,
    NonAppliedSubtitleContainer,
    Row,
    SavingsTextWrapper,
    StyledSubtitleText,
    CouponImgContainer,
    StyledText,
} from "./styles";

//constants
import {
    APPLY_COUPON_TEXT,
    COUPON_SECTION_SHAKE_ANIMATION_TIMEOUT,
    CouponSubtitleDimension,
    DINEOUT_SHOW_COUPON_SECTION_ANIMATION_STORAGE_KEY,
} from "@dineout-cart-ui/constants/index";
import { useSessionStorage } from "@swiggy-private/checkout-core";
import { useEffectOnce } from "@swiggy-private/core-ui";

interface IApplyCoupon {
    subtitleLogo?: string;
    subtitle?: string;
    subtitleColour?: string;
    onClickApplyCoupon: () => void;
}

const ApplyCouponContainer: React.FC<IApplyCoupon> = (props: IApplyCoupon) => {
    const { subtitle, subtitleLogo, onClickApplyCoupon, subtitleColour } = props;
    const [showShakeAnimation, setShowShakeAnimation] = useSessionStorage(
        DINEOUT_SHOW_COUPON_SECTION_ANIMATION_STORAGE_KEY,
        true,
    );

    const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffectOnce(() => {
        animationTimeoutRef.current = setTimeout(() => {
            setShowShakeAnimation(false);
        }, COUPON_SECTION_SHAKE_ANIMATION_TIMEOUT);

        return () => {
            animationTimeoutRef?.current && clearTimeout(animationTimeoutRef.current);
        };
    });

    return (
        <NonAppliedContainer showShakeAnimation={showShakeAnimation}>
            <SavingsTextWrapper onClick={onClickApplyCoupon} data-testid="APPLY_COUPON_CODE">
                <StyledText variant="V2.body1.neutral.bold" color="text_High_Emphasis">
                    {APPLY_COUPON_TEXT}
                </StyledText>
                <NonAppliedSubtitleContainer>
                    <Row>
                        {subtitleLogo ? (
                            <CouponImgContainer>
                                <Image
                                    src={subtitleLogo}
                                    height={CouponSubtitleDimension}
                                    width={CouponSubtitleDimension}
                                ></Image>
                            </CouponImgContainer>
                        ) : null}
                        <StyledSubtitleText
                            subtitleColor={subtitleColour || ""}
                            variant="V2.body2.neutral.regular"
                            color="text_Med_Emphasis"
                            data-testid="APPLIED_COUPON_CODE"
                        >
                            <div dangerouslySetInnerHTML={{ __html: subtitle ?? "" }} />
                        </StyledSubtitleText>
                    </Row>
                </NonAppliedSubtitleContainer>
            </SavingsTextWrapper>
            <div>
                <GenericIcon
                    fillColor="text_Med_Emphasis"
                    strokeColor="text_Med_Emphasis"
                    Icon={IconChevronVariant}
                ></GenericIcon>
            </div>
        </NonAppliedContainer>
    );
};

export default memo(ApplyCouponContainer);
